import { all, takeEvery, put } from 'redux-saga/effects';
import siteConfig from '@iso/config/site.config';
import actions from './actions';
import { notification } from '@iso/components';
const gaxios = require('gaxios');
gaxios.instance.defaults = {
    baseURL: siteConfig.siteUrl.API_URL
}

export function* getInsumos(action) {

    const query = action.query ? `?${action.query}` : '';

    const res = yield gaxios.request({
        url: 'api/inventario' + query,
        headers: {
            Authorization: localStorage.getItem('access_token'),
            AuthId: localStorage.getItem('id_token')
        }
    });
    if (!res.data.success) {
        console.log(res.data);
        notification('error', res.data.msg)
    } else {
        yield put({
            type: actions.GET_INSUMOS_SUCCESS,
            payload: res.data.insumos,
        });
    }
}
export function* createInsumo({ payload }) {
    const res = yield gaxios.request({
        url: 'api/inventario',
        method: 'POST',
        data: payload,
        headers: {
            Authorization: localStorage.getItem('access_token'),
            AuthId: localStorage.getItem('id_token')
        }
    });
    if (!res.data.success) {
        notification('error', res.data.msg);
    } else {
        notification('success', res.data.msg);
        yield put({ type: actions.CREATE_INSUMO_SUCCESS, payload: res.data.insumo });
    }
}
export function* editInsumo({ payload }) {
    const res = yield gaxios.request({
        url: 'api/inventario/' + payload._id,
        method: 'PUT',
        data: payload,
        headers: {
            Authorization: localStorage.getItem('access_token'),
            AuthId: localStorage.getItem('id_token')
        }
    });
    if (!res.data.success) {
        notification('error', res.data.msg);
    } else {
        notification('success', res.data.msg);
        yield put({ type: actions.EDIT_INSUMO_SUCCESS, payload });
    }
}
export function* deleteInsumo({ payload }) {
    const res = yield gaxios.request({
        url: 'api/inventario/' + payload,
        method: 'DELETE',
        headers: {
            Authorization: localStorage.getItem('access_token'),
            AuthId: localStorage.getItem('id_token')
        }
    });
    if (!res.data.success) {
        notification('error', res.data.msg);
    } else {
        notification('success', res.data.msg);
        yield put({ type: actions.DELETE_INSUMO_SUCCESS, payload });
    }
}
export function* registroInventario({ payload }) {
    const res = yield gaxios.request({
        url: 'api/inventario/registro/',
        method: 'POST',
        data: payload,
        headers: {
            Authorization: localStorage.getItem('access_token'),
            AuthId: localStorage.getItem('id_token')
        }
    });
    if (!res.data.success) {
        notification('error', res.data.msg);
    } else {
        notification('success', res.data.msg);
        yield put({ type: actions.CREATE_INSUMO_SUCCESS, payload: res.data.insumo });
    }
}

export function* getRegistroInventario(action) {

    const query = action.query ? `?${action.query}` : '';

    const res = yield gaxios.request({
        url: 'api/inventario/registro' + query,
        headers: {
            Authorization: localStorage.getItem('access_token'),
            AuthId: localStorage.getItem('id_token')
        }
    });
    if (!res.data.success) {
        console.log(res.data);
        notification('error', res.data.msg)
    } else {
        yield put({
            type: actions.GET_REGISTRO_SUCCESS,
            payload: res.data.inventario,
        });
    }
}

export default function* rootSaga() {
    yield all([
        yield takeEvery(actions.GET_INSUMOS_REQUEST, getInsumos),
        yield takeEvery(actions.CREATE_INSUMO_REQUEST, createInsumo),
        yield takeEvery(actions.EDIT_INSUMO_REQUEST, editInsumo),
        yield takeEvery(actions.DELETE_INSUMO_REQUEST, deleteInsumo),
        yield takeEvery(actions.SET_REGISTRO_INVENTARIO, registroInventario),
        yield takeEvery(actions.GET_REGISTRO_INVENTARIO, getRegistroInventario)   
    ]);
}
